module.exports = __webpack_public_path__ + "static/media/Arnav_Prasad.bf3efa9b.JPG";